import { render, staticRenderFns } from "./WelcomeVideo.vue?vue&type=template&id=31bb9e6e&scoped=true&"
import script from "./WelcomeVideo.vue?vue&type=script&lang=ts&"
export * from "./WelcomeVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb9e6e",
  null
  
)

export default component.exports